export default {
  LG: 550,
};
